// eslint-disable-next-line import/prefer-default-export
export const SL_REGISTRATION_POPUP_V1 = 'sl_registration_popup_v1';
export const SL_WEB_AD_FREE_MODAL = 'sl_web_ad_free_modal';
export const SL_WEB_SESSIONS_DEMO = 'sl_web_sessions_demo';
export const SL_WEB_PREMIUM_PERKS_AD = 'sl_web_premium_perks_ad';
export const SL_WEB_MOBILE_FORECAST_PAYWALL = 'sl_web_mobile_forecast_paywall';
export const SL_WEB_LOTUS_TOGGLE = 'sl_web_lotus_toggle';
export const SL_LOCALIZED_FEED = 'sl_localized_feed';
